





































































import Vue, { PropType } from 'vue';
import { PaginationData } from '@/types';

export default Vue.extend({
  name: 'PaginationPanel',

  props: {
    data: {
      type: Object as PropType<PaginationData>,
      required: true,
      default: null,
    },
    countLoadedData: {
      type: Number,
      required: false,
      default: 0,
    },
    isCountLoadedData: {
      type: Boolean,
      required: false,
      default: true,
    },
    visiblePages: {
      type: Number,
      required: false,
      default: 3,
    },
  },

  computed: {
    pages(): Array<number> {
      const pages = [] as Array<number>;
      let start = +this.data.currentPage - this.visiblePages;
      let end = +this.data.currentPage + this.visiblePages;

      if (start < 1) {
        start = 1;
      }
      if (end > +this.data.pageCount) {
        end = +this.data.pageCount;
      }

      for (let i = Math.floor(start); i <= Math.ceil(end); i++) {
        pages.push(i);
      }

      return pages;
    },
  },

  methods: {
    setPage(page: number) {
      if (page < 1 || page > +this.data.pageCount) return;

      this.$emit('changeCurrentPage', page);
    },
  },
});
